export default __webpack_public_path__ + "static/media/preston.6064da69.jpg";